<template>
  <f7-page :page-content="false">
    <f7-navbar :title="$t('properties.properties')" :back-link="$t('atras')"></f7-navbar>
    <f7-page-content class="full-height">
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="Property"
        :tableCode="'PROPERTY'"
        :primary="['nombre']"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :massiveActions="false"
        :controlsWidth="120"
      >
        <template v-slot:tableLinks>
          <a class="link" href="/properties/new/">{{$t('common.nueva')}}</a>
        </template>
        <template v-slot:optionsColumn="{item}">
          <f7-link icon-f7="eye" color="green" :href="`/properties/view/${item.nombre}/`" v-tooltip="$t('common.ver')"></f7-link>
          <f7-link icon-f7="square_pencil" color="blue" :href="`/properties/edit/${item.nombre}/`" v-tooltip="$t('common.editar')"></f7-link>
          <f7-link icon-f7="trash" color="red" @click="$refs.rlist.deleteItem(item.nombre)" v-tooltip="$t('common.eliminar')"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
  </f7-page>
</template>

<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import Property from "./../../js/db/Property.js";

export default {
  components: {
    rDynamicList
  },
  data() {
    return {
      Property
    };
  }
};
</script>
